import { useCallback } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const PARAM = "open";

export function useOpenSessionParam() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const openId = searchParams.get(PARAM);

  const buildUrl = useCallback((id: string | null) => {
    const next = new URLSearchParams(searchParams);
    if (id) next.set(PARAM, id);
    else next.delete(PARAM);
    const qs = next.toString();
    return qs ? `${pathname}?${qs}` : pathname;
  }, [pathname, searchParams]);

  const pushOpen = useCallback((id: string) => {
    router.push(buildUrl(id));
  }, [router, buildUrl]);

  const replaceOpen = useCallback((id: string) => {
    router.replace(buildUrl(id));
  }, [router, buildUrl]);

  const closeOpen = useCallback(() => {
    router.replace(buildUrl(null));
  }, [router, buildUrl]);

  return { openId, pushOpen, replaceOpen, closeOpen };
}
